
import { useMutation } from '@apollo/client';
import { useAuth } from 'components/custom/authprovider';
import { GET_ADMINTRANSACTION_DETAILS } from 'graphql/admin/mutations/transactions';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
  CardHeader,
  CardBody,
  Card,
  Col,
  Row,
  Container,
  Input,
  Button
} from 'reactstrap';
import { SimpleFormatTransactionID } from 'utils/functions';
import sendMutationContext from 'utils/sendContext';
import '../../assets/css/admin.css';
import AdminNav from './AdminNav';
import TransactionCard from './components/transaction';

function GenerateReceipt() {
  const { wt } = useAuth();

  const [logoutFlag, setLogoutFlag] = useState();
  const [transactionID, setTransactionID] = useState("");
  const { ctransactionid } = useParams();
  const [transaction, setTransaction] = useState();

  const [adminTransactionLookup, { loading }] = useMutation(GET_ADMINTRANSACTION_DETAILS, sendMutationContext(wt, setLogoutFlag));

  const history = useHistory();
  const location = useLocation();
  const initialPathRef = useRef(location.pathname);
  const basePath = (() => {
    const current = initialPathRef.current;
    const lastSlashIndex = current.lastIndexOf('/');

    if (current.slice(lastSlashIndex, current.length) == "/generate-receipt") {
      return current + "/";
    }

    return current.slice(0, lastSlashIndex + 1);
  })();

  useEffect(() => {
    if (ctransactionid) {
      setTransactionID(ctransactionid);
      searchTransaction(ctransactionid);
    }

    if (logoutFlag) {
      history.push("/admin/logout");
    }
  }, [logoutFlag, history]);

  const searchTransaction = async (searchTransactionId = undefined) => {
    if (!logoutFlag) {
      if (transactionID !== "") {
        searchTransactionId = transactionID;
      }

      if (!searchTransactionId || searchTransactionId == "") {
        history.replace({ pathname: basePath });

        setTransaction();
        return;
      }

      const data = await adminTransactionLookup({ variables: { transactionid: searchTransactionId } });
      if (data && data.data && data.data.adminTransactionLookup.error === null && searchTransactionId) {
        history.replace({ pathname: basePath + searchTransactionId });

        setTransaction(data.data.adminTransactionLookup.transaction);
      } else {
        history.replace({ pathname: basePath + searchTransactionId });

        setTransaction();
      }
    }
  };

  return (
    <div className="admin-wrapper">
      <AdminNav />

      <Container fluid className="content">
        <Row>
          <Col md="12">
            <Card className="card-dark">
              <CardHeader className="card-header-dark">
                <Row>
                  <Col lg="8" md="6" sm="6">
                    Generate Receipt
                  </Col>

                  <Col lg="2" md="3" sm="3" style={{ textAlign: "right" }}>
                    <Input type="text" value={transactionID}
                      placeholder='Transaction ID Search'
                      onChange={(e) => setTransactionID(SimpleFormatTransactionID(e.target.value))}
                    />
                  </Col>

                  <Col lg="2" md="3" sm="3" style={{ textAlign: "right" }}>
                    <Button
                      color={"success"}
                      onClick={() => searchTransaction()}
                    >
                      Search Transaction
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  {!transaction && !loading &&
                    <span>No transaction found!</span>
                  }

                  {loading &&
                    <span>Searching...</span>
                  }

                  {!loading && transaction &&
                    <Col lg="6" md="6" className="customer-card ">
                      <TransactionCard transaction={transaction} />
                    </Col>
                  }
                </Row>
                <Row>
                  <p>This will allow ondemand receipt generation based on a transaction id</p>
                </Row>
                <Row>
                  <p>Show Iframe with html file</p>
                </Row>
                <Row>
                  <p>Force download</p>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default GenerateReceipt;